import { Component, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import {
  AlertController,
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Slides,
  ToastController
} from "ionic-angular";
import { Evento } from "../../../domain/evento";
import { EnderecoProvider } from "../../../providers/endereco/endereco.provider";
import { AnonymizeProvider } from "../../../providers/anonymize/anonymize.provider";
import { ParticipacaoPage } from "../../participacao/participacao";
import { Contrato } from "./../../../domain/contrato";
import { ContratoProvider } from "./../../../providers/contrato/contrato.provider";
import { ContratosPage } from "./../contratos";
import { ContratoValidate } from "./../contratos.validate";

@IonicPage({
  name: "contrato-form",
  segment: "contrato-form/:id",
})
@Component({
  selector: "contrato-form",
  templateUrl: "contrato-form.html",
})
export class ContratoFormPage {
  public contrato: Contrato;
  public evento_aberto: Evento;

  public loaded: boolean = false;
  private form: FormGroup;
  @ViewChild(Slides) slides: Slides;

  contratoId: any;
  title: string;
  titleIcon: string;

  // Variables for name editing
  isEditingName: boolean = false;
  originalName: string = '';
  tempName: string = '';
  nomeTitular: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,

    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    private alertCtrl: AlertController,
    public _loadingController: LoadingController,

    private contratoProvider: ContratoProvider,
    private enderecoProvider: EnderecoProvider,
    private formBuilder: FormBuilder,
    public contratoValidate: ContratoValidate,
    public anonymizeProvider: AnonymizeProvider
  ) {
    console.info('[CONTRATO-FORM] Inicializando formulário de contrato');
    
    if (this.getEventoAberto()) {
      this.contratoId = this.navParams.get("id");
      this.setForm();
      console.info('[CONTRATO-FORM] ContratoId:', this.contratoId);

      if (this.contratoId !== undefined && this.contratoId > 0) {
        this.title = "Editar Contrato";
        this.titleIcon = "create";
        this.getData(this.contratoId);

        this.form.controls["local_cadastro"].setValidators(null);
        this.form.controls["como_conheceu"].setValidators(null);

        this.form.updateValueAndValidity();
      } else {
        this.title = "Novo Contrato";
        this.titleIcon = "person-add";

        // ECOENEL-258: pré-preenche o NUC buscado quando o cadastro vem da busca em campo
        const numeroParam = this.navParams.get("numero");
        if (numeroParam) {
          this.form.controls["numero"].setValue(numeroParam);
        }
      }

      this.loaded = true;
    } else {
      this.loaded = false;
    }
  }

  ionViewDidLoad() {}

  submitForm() {
    this.contrato = this.formatData();

    let loading = this._loadingController.create({
      content: "Salvando Contrato...",
    });
    //let self = this;
    let toast = this.toastCtrl.create({ duration: 1500 });
    loading.present();

    this.contratoProvider
      .save(this.contrato)
      .then((success) => {
        loading.dismiss();
        this.acaoPosSalvar(success);
      })
      .catch((error) => {
        toast.setMessage("Erro no formulário : " + error);
        toast.present();
        loading.dismiss();
      });
  }

  getEndereco() {
    let cep = this.form.controls["cep"].value;
    if (cep.length === 8) {
      let loading = this._loadingController.create({
        content: "Procurando endereço...",
      });
      loading.present();

      this.enderecoProvider.getByCEP(cep).subscribe((endereco) => {
        let infoEndereco =
          endereco.bairro + "\n" + endereco.localidade + "/" + endereco.uf;

        this.form.controls["infoEndereco"].setValue(infoEndereco);
        this.form.controls["endereco"].setValue(endereco.logradouro);

        loading.dismiss();
      });
    }
  }

  formatField(tipo: string, field: string) {
    if (field) return this.contratoValidate.define(tipo, field);
    return field;
  }

  // Methods for name editing - only used in edit mode
  startEditingName() {
    // Only proceed if in edit mode
    if (this.contratoId === undefined || this.contratoId <= 0) return;

    this.isEditingName = true;
    this.originalName = this.form.controls["nomeTitular"].value;
    this.form.controls["nomeTitular"].setValue('');
  }

  cancelEditingName() {
    // Only proceed if in edit mode
    if (this.contratoId === undefined || this.contratoId <= 0) return;

    this.isEditingName = false;
    this.form.controls["nomeTitular"].setValue(this.originalName);
  }

  confirmEditingName() {
    // Only proceed if in edit mode
    if (this.contratoId === undefined || this.contratoId <= 0) return;

    this.isEditingName = false;
    const newName = this.form.controls["nomeTitular"].value;
    if (newName) {
      // Apply LGPD mask to the new name
      const anonymizedName = this.anonymizeProvider.anonymizeName(newName);
      // Store the real name in the form control for submission
      this.form.controls["nomeTitular"].setValue(newName);
      // Display the anonymized name
      this.nomeTitular = anonymizedName;
    } else {
      // If the field is empty, restore the original name
      this.form.controls["nomeTitular"].setValue(this.originalName);
    }
  }

  /* Privates  */
  private getData(id: number) {
    let loading = this._loadingController.create({
      content: "Carregando Contrato...",
    });
    loading.present();

    this.contratoProvider.getById(this.contratoId).subscribe((res) => {
      let contrato = res;

      this.form.controls["email"].setValue(contrato.cliente.email);
      //celualar only digits
      this.form.controls["celular"].setValue(contrato.cliente.celular ? contrato.cliente.celular.replace(/\D/g, "") : "");
      // Store the real name in the form control
      this.form.controls["nomeTitular"].setValue(contrato.nomeTitular);
      // Store the original name for reference
      this.originalName = contrato.nomeTitular;
      // Display the anonymized name when not in editing mode
      if (!this.isEditingName) {
        this.nomeTitular = this.anonymizeProvider.anonymizeName(contrato.nomeTitular);
      }
      this.form.controls["numero"].setValue(contrato.numero);
      this.form.controls["cpf_cnpj_titular"].setValue(
        contrato.cpf_cnpj_titular
      );
      this.form.controls["numeroMedidor"].setValue(contrato.numeroMedidor);
      this.form.controls["tensao"].setValue(contrato.tensao);

      this.form.controls["cep"].setValue(contrato.cep);
      this.form.controls["endereco"].setValue(contrato.endereco);
      this.form.controls["numeroEndereco"].setValue(contrato.numeroEndereco);
      this.form.controls["complementoEndereco"].setValue(
        contrato.complementoEndereco
      );

      // this.getEndereco();
      loading.dismiss();
    });
  }

  private setForm() {
    this.form = this.formBuilder.group({
      nomeTitular: ["", Validators.required],
      numero: ["", Validators.required],
      cpf_cnpj_titular: [""],
      numeroMedidor: [""],
      tensao: [""],
      cep: [""],
      infoEndereco: new FormControl({ value: "", disabled: true }),
      endereco: [""],
      numeroEndereco: [""],
      complementoEndereco: [""],
      celular: [""],
      email: [""],
      local_cadastro: new FormControl(
        { value: this.evento_aberto.local.nome, disabled: true },
      ),
      como_conheceu: [""],
    });
  }

  private formatData(): Contrato {
    let contrato: Contrato = this.form.value;
    if (this.form.value.cpf_cnpj_titular) {
      contrato.cpf_cnpj_titular = this.form.value.cpf_cnpj_titular
      .replace(/\./g, "")
      .replace(/-/g, "")
    }

    contrato.status = "A";

    if (this.contratoId !== undefined && this.contratoId > 0) {
      contrato.id = this.contratoId;
    } else {
      let cliente: any = {
        nome: this.form.value.nomeTitular,
        cpf: contrato.cpf_cnpj_titular,
        evento_id: this.evento_aberto.id,
        celular: (this.form.value.celular || "")
          .replace(/\(/g, "")
          .replace(/\)/g, "")
          .replace(/-/g, ""),
        email: this.form.value.email,
        como_conheceu: this.form.value.como_conheceu,
      };
      contrato.cliente = cliente;
    }

    return contrato;
  }

  private getEventoAberto(): any {
    if (localStorage.getItem("evento_aberto")) {
      this.evento_aberto = JSON.parse(localStorage.getItem("evento_aberto"));
      return true;
    } else {
      let toast = this.toastCtrl.create({ duration: 1500 });
      let self = this;
      toast.setMessage("Selecione um evento antes de continuar!");
      toast.present();
      toast.onDidDismiss(() => {
        self.navCtrl.setRoot("HomePage");
      });
      return false;
    }
  }

  private acaoPosSalvar(result: any) {
    let msg =
      !(this.contratoId > 0)
        ? "Contrato Cadastrado!"
        : "Contrato Editado!";
    let alert = this.alertCtrl.create({
      title: msg,
      subTitle: "Ir direto para Reciclagem de " + this.anonymizeProvider.anonymizeName(result.nomeTitular) + " ? ",
      buttons: [
        {
          text: "Voltar para Contratos",
          role: "voltar",
          handler: () => {
            this.navCtrl.push(ContratosPage, {});
          },
        },
        {
          text: "SIM",
          handler: () => {
            this.navCtrl.push(ParticipacaoPage, {
              id: result.id,
            });
          },
        },
      ],
    });
    alert.present();
  }

  slideNext() {
    this.slides.slideNext();
  }

  slidePrev() {
    this.slides.slidePrev();
  }
}



// WEBPACK FOOTER //
// ./src/pages/contratos/contrato-form/contrato-form.ts